"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/button";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/shared/ui/input-otp";
import { Spinner } from "@/shared/ui/spinner";
type VerifyStepProps = {
  maskedPhone: string;
  onVerified: () => void;
  onChangePhone: () => void;
};
const CODE_LENGTH = 4;
const RESEND_SECONDS = 60;
const MOCK_DELAY_MS = 800;
export function VerifyStep(t0) {
  const $ = _c(67);
  const {
    maskedPhone,
    onVerified,
    onChangePhone
  } = t0;
  const {
    t
  } = useTranslation();
  const [code, setCode] = useState("");
  const [secondsLeft, setSecondsLeft] = useState(RESEND_SECONDS);
  const [isVerifying, setIsVerifying] = useState(false);
  let t1;
  let t2;
  if ($[0] !== secondsLeft) {
    t1 = () => {
      if (secondsLeft <= 0) {
        return;
      }
      const id = window.setInterval(() => {
        setSecondsLeft(_temp);
      }, 1000);
      return () => window.clearInterval(id);
    };
    t2 = [secondsLeft];
    $[0] = secondsLeft;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== code.length || $[4] !== isVerifying || $[5] !== onVerified) {
    t3 = async () => {
      if (code.length !== CODE_LENGTH || isVerifying) {
        return;
      }
      setIsVerifying(true);
      await new Promise(_temp2);
      onVerified();
    };
    $[3] = code.length;
    $[4] = isVerifying;
    $[5] = onVerified;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleVerify = t3;
  let t4;
  if ($[7] !== secondsLeft) {
    t4 = () => {
      if (secondsLeft > 0) {
        return;
      }
      setSecondsLeft(RESEND_SECONDS);
      setCode("");
    };
    $[7] = secondsLeft;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleResend = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Array.from({
      length: CODE_LENGTH
    }, _temp3);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const slots = t5;
  const t6 = String(Math.floor(secondsLeft / 60));
  let t7;
  if ($[10] !== t6) {
    t7 = t6.padStart(2, "0");
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = String(secondsLeft % 60);
  let t9;
  if ($[12] !== t8) {
    t9 = t8.padStart(2, "0");
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const timeLabel = `${t7}:${t9}`;
  let t10;
  if ($[14] !== t) {
    t10 = t("landing.accountDeletion.verifyTitle");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <h2 className="text-lg font-semibold text-slate-900">{t10}</h2>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== maskedPhone || $[19] !== t) {
    t12 = t("landing.accountDeletion.codeSentTo", {
      phone: maskedPhone
    });
    $[18] = maskedPhone;
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <p className="text-muted-foreground mt-1 text-sm">{t12}</p>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <div className="text-center">{t11}{t13}</div>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== handleVerify) {
    t15 = event => {
      event.preventDefault();
      handleVerify();
    };
    $[26] = handleVerify;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = value_0 => setCode(value_0.replace(/\D/g, "").slice(0, CODE_LENGTH));
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <InputOTPGroup>{slots.map(_temp4)}</InputOTPGroup>;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== code || $[31] !== isVerifying) {
    t18 = <div className="flex justify-center"><InputOTP autoFocus={true} maxLength={CODE_LENGTH} value={code} onChange={t16} disabled={isVerifying}>{t17}</InputOTP></div>;
    $[30] = code;
    $[31] = isVerifying;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const t19 = isVerifying || code.length !== CODE_LENGTH;
  let t20;
  if ($[33] !== isVerifying) {
    t20 = isVerifying && <Spinner />;
    $[33] = isVerifying;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== isVerifying || $[36] !== t) {
    t21 = isVerifying ? t("landing.accountDeletion.verifying") : t("landing.accountDeletion.verify");
    $[35] = isVerifying;
    $[36] = t;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t19 || $[39] !== t20 || $[40] !== t21) {
    t22 = <Button type="submit" className="w-full" variant="destructive" disabled={t19}>{t20}{t21}</Button>;
    $[38] = t19;
    $[39] = t20;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t) {
    t23 = t("landing.accountDeletion.changePhone");
    $[42] = t;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== isVerifying || $[45] !== onChangePhone || $[46] !== t23) {
    t24 = <Button type="button" variant="ghost" size="sm" onClick={onChangePhone} disabled={isVerifying}>{t23}</Button>;
    $[44] = isVerifying;
    $[45] = onChangePhone;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  const t25 = secondsLeft > 0 || isVerifying;
  let t26;
  if ($[48] !== secondsLeft || $[49] !== t || $[50] !== timeLabel) {
    t26 = secondsLeft > 0 ? t("landing.accountDeletion.resendIn", {
      time: timeLabel
    }) : t("landing.accountDeletion.resend");
    $[48] = secondsLeft;
    $[49] = t;
    $[50] = timeLabel;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== handleResend || $[53] !== t25 || $[54] !== t26) {
    t27 = <Button type="button" variant="link" size="sm" onClick={handleResend} disabled={t25}>{t26}</Button>;
    $[52] = handleResend;
    $[53] = t25;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t24 || $[57] !== t27) {
    t28 = <div className="flex items-center justify-between gap-2 text-sm">{t24}{t27}</div>;
    $[56] = t24;
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t15 || $[60] !== t18 || $[61] !== t22 || $[62] !== t28) {
    t29 = <form noValidate={true} onSubmit={t15} className="flex flex-col gap-4">{t18}{t22}{t28}</form>;
    $[59] = t15;
    $[60] = t18;
    $[61] = t22;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== t14 || $[65] !== t29) {
    t30 = <div className="mt-8 flex flex-col gap-4">{t14}{t29}</div>;
    $[64] = t14;
    $[65] = t29;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  return t30;
}
function _temp4(index_0) {
  return <InputOTPSlot key={index_0} index={index_0} className="size-11 text-base" />;
}
function _temp3(_, index) {
  return index;
}
function _temp2(resolve) {
  return setTimeout(resolve, MOCK_DELAY_MS);
}
function _temp(value) {
  return Math.max(0, value - 1);
}